import { useMemo } from 'react'

import { useGetUserQuery } from 'common'

import { COUNTRY_CODES } from '../constants'

export const useCurrentlySupportedCountries = () => {
  const {
    data: {
      country_code: userCountryCode,
      profile: { available_countries: availableCountries }
    }
  } = useGetUserQuery()

  const supportedCountries = useMemo(() => COUNTRY_CODES.map((countryCode) => {
    const [code, name] = availableCountries.find(([value]) => value === countryCode)

    return { code, name }
  }), [availableCountries])

  return {
    supportedCountries,
    userCountryCode
  }
}
